import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const exportShipments = (requestUrl, requestBody) => {
  const post = axios.post(requestUrl, requestBody).then((response) => {
    return get(response, 'data');
  });

  const post$ = from(post);
  return post$;
};

export const customExportShipments = (requestBody, requestUrl = undefined) => {
  const url = requestUrl || '/seller/customextracts/exportShipments';
  const post = axios.post(url, requestBody).then((response) => {
    return get(response, 'data');
  });
  const post$ = from(post);
  return post$;
};
